import { render, staticRenderFns } from "./sound-identicator.vue?vue&type=template&id=79226032"
import script from "./sound-identicator.vue?vue&type=script&lang=js"
export * from "./sound-identicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79226032')) {
      api.createRecord('79226032', component.options)
    } else {
      api.reload('79226032', component.options)
    }
    module.hot.accept("./sound-identicator.vue?vue&type=template&id=79226032", function () {
      api.rerender('79226032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sound-identicator.vue"
export default component.exports